import React from 'react'
import Text from '../../../../components/Text'
import ProceedButton from '../../../../components/Signup/ProceedButton'
import RadioButton from '../../../../components/RadioButton/RadioButton'

const IdentifyUser = ({ onMoveNext, isLastStep, onChange, value }) => {
  const handleChange = () => {
    onMoveNext(value)
  }

  return (
    <div className="z-10 pt-12 px-4">
      <Text
        variant="display"
        size="small"
        className="text-[#101828] mb-4"
        tag="h2"
      >
        Please let us know who you are
      </Text>

      <div className="flex flex-col gap-4 mt-12 pb-10">
        <RadioButton
          className="w-full"
          label="Patient"
          description="I am fighting cancer."
          isSelected={value === 'patient'}
          onClick={() => onChange('userType', 'patient')}
        />
        <RadioButton
          className="w-full"
          label="Caregiver"
          description="Taking care of my loved one suffering from  cancer."
          isSelected={value === 'caregiver'}
          onClick={() => onChange('userType', 'caregiver')}
        />
      </div>

      <ProceedButton
        onMoveNext={handleChange}
        isLastStep={isLastStep}
        disabled={!value}
        infoText="We recommend that the patient should sign up for the program."
      />
    </div>
  )
}

export default IdentifyUser
